import { Injectable } from "@angular/core";

@Injectable()
export class DurationFormatService {
  public format(milliseconds: number): [string, string] {
    let value: string;
    let unit: string;

    if (milliseconds == null) {
      value = "0";
      unit = "";
    } else if (milliseconds < 1000) {
      value =
        milliseconds % 1 !== 0 ? milliseconds.toFixed(2) : String(milliseconds);
      unit = "ms";
    } else if (milliseconds < 60000) {
      value = (Math.floor(milliseconds / 100) / 10).toFixed(2);
      unit = "s";
    } else if (milliseconds < 3600000) {
      const min = milliseconds / 60000;
      value = min % 1 !== 0 ? min.toFixed(1) : String(min);
      unit = "min";
    } else {
      const hour = milliseconds / 3600000;
      value = hour % 1 !== 0 ? hour.toFixed(1) : String(hour);
      unit = "h";
    }

    return [value, unit];
  }
}
